export default __webpack_public_path__ + "assets/front/scss/user-profile.936e9618eaadd29c698cfb4b4c53a1af.css";